<template>
  <v-container fluid>
    <v-row>
      <h1>Access denied</h1>
      <button @click="logOut">Sign out</button>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AccessDenied",
  methods: {
    logOut() {
      this.$msal.signOut();
    }
  }
};
</script>